import React from 'react';
import { connect } from 'react-redux';
import { Switch, Route, Redirect } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';

import LoginContainer from './containers/public/LoginContainer';
import ContentContainer from './containers/private/ContentContainer';
import ModalsContainer from './containers/ModalsContainer';
import Button from './components/basic/Button';
import { history } from './store';

import * as loginActions from './actions/login/LoginActions';
import { BRAND } from './constants/Constants';

import './App.css';

const App = ({ auth, logout }) => {
  const loggedIn = auth && auth.access_token;
  return (
    <div className={`App brand-${BRAND.key}`}>
      <div className="App-header">
        <div className="App-title">
          <div className="App-logo-container">
            <img className="App-logo" src={`/branding/${BRAND.folder()}/logo.svg`} alt={BRAND.label}/>
          </div>
          <span style={{ borderBottomColor: BRAND.theme.palette.accent1Color }}>Admin</span>
        </div>
        <div className="App-controls">
          {loggedIn && <Button style={{ color: '#fff' }} label="Logout" onClick={logout} />}
        </div>
      </div>
      <ConnectedRouter history={history}>
        <Switch>
          <Route path="/login" render={() => (loggedIn ? <Redirect to="/settings/companies" /> : <LoginContainer />)} />
          <Route path="*" render={() => (loggedIn ? <ContentContainer /> : <Redirect to="/login" />)} />
        </Switch>
      </ConnectedRouter>
      <ModalsContainer />
      <div className="App-footer">Footer</div>
    </div>
  );
};

const mapStateToProps = ({ auth }) => ({ auth });

export default connect(mapStateToProps, loginActions)(App);



// WEBPACK FOOTER //
// ./src/App.js